import { If } from 'cdui-js';
import i18n from '../../../i18n';
import { IconChevronRight } from './icons';
import { currencyLabel, logoChar, logoColor, type BankCard } from './shared';

type BankCardViewProps = {
  item: BankCard;
  showArrow?: boolean;
  showPending?: boolean;
  onClick?: () => void;
};

export const BankCardView = (props: BankCardViewProps) => {
  const name = () => props.item.displayName || props.item.bankName;
  const tag = () => props.item.tagText || currencyLabel(props.item.currency);

  return (
    <div class="bank-card" onclick={() => props.onClick?.()}>
      <div class="bank-card-left">
        <div class="bank-card-top">
          <div class="logo" style={{ background: logoColor(name()) }}>
            {logoChar(name())}
          </div>
          <div class="bank-card-info">
            <div class="bank-name">{name() || '-'}</div>
            <div class="bank-no">{props.item.bankAccountNum || '-'}</div>
          </div>
        </div>
        <If when={!!tag()}>
          <div class="bank-currency">{tag()}</div>
        </If>
      </div>
      <If when={props.showPending && props.item.pending}>
        <span class="pending">{i18n.BankList.Pending}</span>
      </If>
      <If when={props.showArrow && !props.item.pending}>
        <span class="bank-arrow">
          <IconChevronRight />
        </span>
      </If>
    </div>
  );
};
